function finiteUsd(value: number | null): number | null {
	return value !== null && Number.isFinite(value) ? value : null
}

/**
 * Positions read top-to-bottom as a value ranking. Exact ties retain the
 * wallet's source order, while missing or invalid valuations stay at the end.
 */
export function sortByUsdValue<T extends { usd: number | null }>(rows: readonly T[]): T[] {
	return [...rows].sort((a, b) => {
		const aUsd = finiteUsd(a.usd)
		const bUsd = finiteUsd(b.usd)

		if (aUsd === null) return bUsd === null ? 0 : 1
		if (bUsd === null) return -1
		return bUsd - aUsd
	})
}
